import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAppSelector } from "~/hooks/appSelector";
import {ComponentRequest} from "~/models/Commons ";
import { useSaveComponentsMutation } from "~/services/vm/Components";
import { selectProvider } from "~/store/feature/Provider";

export const UseVmComponentsForm = ( onCloseModal: () => void,refetch: () => void) => {
  const { cloudProviderName } = useAppSelector(selectProvider);
   const [saveComponents, {isLoading }] = useSaveComponentsMutation();
 

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm<ComponentRequest>({
    defaultValues: {
      typeId:undefined,
      name:  "",
      description:"",
      content:""
    },
  });

const submitForm = async (data: ComponentRequest, typeId: number) => {
  try {
    const payload: ComponentRequest = {
      ...data,
      typeId,
    };

    const response = await saveComponents(payload).unwrap();

    if (response?.success) {
      toast.success(response?.message ?? 'Component saved successfully');
    } else {
      throw new Error('Save operation failed: No success flag in response');
    }
  } catch (error: any) {
    const errorTitle = error?.data?.title ?? error?.title ?? 'Unknown error';
    const errorStatus = error?.data?.status ?? error?.status ?? 'N/A';

    toast.error(`Status: ${errorStatus}\nTitle: ${errorTitle}`);
    console.error('submitForm: error occurred', error);
  } finally {
    refetch();
    onCloseModal();
    console.log('submitForm: completed');
  }
};
  
  return {
    handleSubmit,
    control,
    errors,
    submitForm,
    cloudProviderName,
    reset,
    setValue
  };
}